// firebase-config.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyD3r_GjKUAaeEnZYnpkVVlSUctRtMwsPN0",
  authDomain: "gpforum-f8d4d.firebaseapp.com",
  projectId: "gpforum-f8d4d",
  storageBucket: "gpforum-f8d4d.appspot.com",
  messagingSenderId: "273317509182",
  appId: "1:273317509182:web:3f61d0609efb9c52ebb96f",
  measurementId: "G-EHZ8KGK7P3",
};

let app = null;
let auth = null;
let db = null;

// Only initialize Firebase in the browser, not during SSR
if (typeof window !== "undefined") {
  app = initializeApp(firebaseConfig);
  auth = getAuth(app);
  db = getFirestore(app);
}

// Export for your other files to import
export { auth, db };
